export default "__VITE_ASSET__CgovPWOM__"